(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colectie-produse"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('dropky-product-shelf')) {

    class DropkyProductShelf extends HTMLElement {

      connectedCallback() {

        queueMicrotask(() => this.initialize());

      }

      disconnectedCallback() {

        if (this.controller) this.controller.abort();

        this.initialized = false;

      }

      normalize(value) {

        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('ro').trim();

      }

      initialize() {

        if (this.initialized || !this.isConnected) return;

        this.grid = this.querySelector('[data-dps-grid]');

        if (!this.grid) return;

        this.initialized = true;

        this.controller = new AbortController();

        const options = { signal: this.controller.signal };

        this.cards = Array.from(this.grid.querySelectorAll('[data-dps-card]'));

        this.filters = this.querySelector('[data-dps-filters]');

        this.search = this.querySelector('[data-dps-search]');

        this.sort = this.querySelector('[data-dps-sort]');

        this.empty = this.querySelector('[data-dps-empty]');

        this.result = this.querySelector('[data-dps-result]');

        this.activeCategory = '';
        this.editorSelectedBlockId = '';
        this.desktopMedia = window.matchMedia('(min-width: 750px)');
        this.buildFilters();

        this.querySelector('[data-dps-toolbar]').hidden = !(this.search || this.sort || !this.filters.hidden);

        this.addEventListener('click', (event) => {

          const filter = event.target.closest('[data-dps-category]');

          if (filter && this.contains(filter)) {

            this.activeCategory = filter.dataset.dpsCategory;

            this.apply();

          }

          if (event.target.closest('[data-dps-reset]')) this.reset();

        }, options);

        if (this.search) this.search.addEventListener('input', () => this.apply(), options);

        if (this.sort) this.sort.addEventListener('change', () => this.apply(), options);

        document.addEventListener('shopify:block:select', (event) => {

          if (!event.detail) return;

          if (event.detail.sectionId && String(event.detail.sectionId) !== this.dataset.sectionId) return;

          const card = this.cards.find((element) => element.dataset.blockId === String(event.detail.blockId));

          if (!card) return;

          this.editorSelectedBlockId = String(event.detail.blockId);
          this.reset();
          card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });

        }, options);

        const handleLayoutChange = () => this.apply();
        if (this.desktopMedia.addEventListener) {
          this.desktopMedia.addEventListener('change', handleLayoutChange, options);
        } else {
          window.addEventListener('resize', handleLayoutChange, options);
        }
        document.addEventListener('shopify:block:deselect', (event) => {
          if (this.editorSelectedBlockId && event.detail && String(event.detail.blockId) === this.editorSelectedBlockId) {
            this.editorSelectedBlockId = '';
            this.apply();
          }
        }, options);
        this.apply();

    }

    buildFilters() {

        this.filters.replaceChildren();

        const categories = new Map();

        this.cards.forEach((card) => {

          const label = (card.dataset.category || '').trim();

          const key = this.normalize(label);

          if (!key) return;

          const category = categories.get(key) || { label, count: 0 };

          category.count += 1;

          categories.set(key, category);

        });

        if (this.dataset.showFilters !== 'true' || categories.size < 2) {

          this.filters.hidden = true;

          return;

        }

        this.filters.hidden = false;

        const addButton = (key, label, count) => {

          const button = document.createElement('button');

          button.type = 'button';

          button.className = 'dps__filter';

          button.dataset.dpsCategory = key;

          button.setAttribute('aria-pressed', key === '' ? 'true' : 'false');

          button.setAttribute('aria-controls', this.grid.id);

          const text = document.createElement('span');

          text.textContent = label;

          const counter = document.createElement('span');

          counter.className = 'dps__filter-count';

          counter.textContent = count;

          counter.setAttribute('aria-hidden', 'true');

          button.append(text, counter);

          this.filters.append(button);

        };

        addButton('', this.dataset.allLabel || 'Toate', this.cards.length);

        categories.forEach((category, key) => addButton(key, category.label, category.count));

      }

      reset() {

        this.activeCategory = '';

        if (this.search) this.search.value = '';

        if (this.sort) this.sort.value = 'manual';

        this.apply();

      }

      apply() {

        const query = this.normalize(this.search ? this.search.value : '');

        const words = query.split(/\s+/).filter(Boolean);

        const sortMode = this.sort ? this.sort.value : 'manual';

        let matchCount = 0;
        const desktopLimit = Math.max(1, Number(this.dataset.desktopLimit) || 5);
        const mobileLimit = Math.max(1, Number(this.dataset.mobileLimit) || 6);
        const limit = this.desktopMedia && this.desktopMedia.matches ? desktopLimit : mobileLimit;

        const sorted = this.cards.slice().sort((left, right) => {

          if (sortMode !== 'manual') {

            const placeholderDifference = Number(left.dataset.placeholder === 'true') - Number(right.dataset.placeholder === 'true');

            if (placeholderDifference) return placeholderDifference;

          }

          if (sortMode === 'price-asc' || sortMode === 'price-desc') {

            const difference = Number(left.dataset.price) - Number(right.dataset.price);

            if (difference) return sortMode === 'price-desc' ? -difference : difference;

          }

          if (sortMode === 'title') {

            const difference = (left.dataset.title || '').localeCompare(right.dataset.title || '', 'ro', { sensitivity: 'base' });

            if (difference) return difference;

          }

          return Number(left.dataset.index) - Number(right.dataset.index);

        });

        const fragment = document.createDocumentFragment();

        sorted.forEach((card) => {

          const categoryMatches = !this.activeCategory || this.normalize(card.dataset.category) === this.activeCategory;

          const haystack = this.normalize(card.dataset.search);

          const queryMatches = words.every((word) => haystack.includes(word));

          const matches = categoryMatches && queryMatches;
          if (matches) matchCount += 1;
          const selectedInEditor = this.editorSelectedBlockId && card.dataset.blockId === this.editorSelectedBlockId;
          card.hidden = !(selectedInEditor || (matches && matchCount <= limit));

          fragment.append(card);

        });

        this.grid.append(fragment);

        this.filters.querySelectorAll('[data-dps-category]').forEach((button) => {

          button.setAttribute('aria-pressed', button.dataset.dpsCategory === this.activeCategory ? 'true' : 'false');

        });

        this.empty.hidden = matchCount !== 0;
        this.result.hidden = false;

      }

    }

    customElements.define('dropky-product-shelf', DropkyProductShelf);

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-dropky"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('dk-dropky-bite-hero')) return;
  class DropkyBiteHero extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.tick);
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      try { this.product = JSON.parse(this.querySelector('[data-dkyb-product]')?.textContent || '[]')[0] || {}; }
      catch { this.product = {}; }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false; this.editorPaused = false; this.complete = false;
      this.inView = !('IntersectionObserver' in window);
      this.sceneInView = this.inView;
      this.classList.remove('is-complete');
      this.controls = this.querySelector('[data-dkyb-motion]');
      this.pauseButton = this.querySelector('[data-dkyb-pause]');
      this.timer = this.querySelector('[data-dkyb-timer]');
      this.timerSlot = this.querySelector('[data-dkyb-timer-slot]');
      this.timerHelp = this.querySelector('[data-dkyb-timer-help]');
      this.timerMedia = matchMedia('(min-width:761px)');
      this.timerMedia.addEventListener('change',() => this.relocateTimer(),options);
      this.relocateTimer();
      this.deadline = this.parseDate(this.timer?.dataset.end || '');
      this.expiredSent = false;
      this.addEventListener('click',event => {
        if (event.target.closest('[data-dkyb-replay]')) { this.userPaused = false; this.restart(); this.dispatchEvent(new CustomEvent('dropky:hero-animation-replay',{bubbles:true,detail:this.eventDetail()})); }
        if (event.target.closest('[data-dkyb-pause]')) {
          if (this.complete) { this.userPaused = false; this.restart(); }
          else { this.userPaused = !this.userPaused; this.update(); }
        }
        if (event.target.closest('[data-dkyb-product-link]') && this.product.product) this.dispatchEvent(new CustomEvent('dropky:hero-product-click',{bubbles:true,detail:this.eventDetail()}));
      },options);
      this.addEventListener('animationend',event => {
        if (event.animationName !== 'dkyb-release' || this.dataset.loop !== 'false') return;
        this.complete = true; this.classList.add('is-complete'); this.update();
      },options);
      document.addEventListener('visibilitychange',() => this.update(),options);
      this.motion.addEventListener('change',() => this.update(),options);
      for (const name of ['shopify:block:select','shopify:block:deselect']) document.addEventListener(name,event => {
        if (!this.contains(event.target) && event.target.closest?.('.shopify-section') !== this.closest('.shopify-section')) return;
        this.editorPaused = name.endsWith(':select'); this.update();
      },options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target===this) this.inView = entry.isIntersecting;
            else this.sceneInView = entry.isIntersecting;
          }
          this.update();
        },{threshold:0.05});
        this.observer.observe(this);
        const art = this.querySelector('.dkyb__art');
        if (art) this.observer.observe(art);
      }
      this.update();
    }
    relocateTimer() {
      if (!this.timerSlot) return;
      const target = this.timerMedia?.matches ? this.querySelector('.dkyb__copy') : this.querySelector('.dkyb__art');
      if (!target || this.timerSlot.parentElement===target) return;
      if (this.timerMedia?.matches) target.append(this.timerSlot);
      else target.prepend(this.timerSlot);
    }
    eventDetail() { return {product_id:this.product.product,variant_id:this.product.variant,source:'dropky_bite_hero'}; }
    parseDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value.trim());
      if (!match) return NaN;
      const [year,month,day,hour,minute,second] = match.slice(1,7).map(n=>Number(n||0));
      if (year<2000 || month<1 || month>12 || day<1 || hour>23 || minute>59 || second>59) return NaN;
      const utc = Date.UTC(year,month-1,day,hour,minute,second), date = new Date(utc);
      if (date.getUTCFullYear()!==year || date.getUTCMonth()!==month-1 || date.getUTCDate()!==day) return NaN;
      const zone = match[7];
      if (zone==='Z') return utc;
      const zoneHour = Number(zone.slice(1,3)),zoneMinute = Number(zone.slice(4,6));
      if (zoneHour>14 || zoneMinute>59 || (zoneHour===14 && zoneMinute!==0)) return NaN;
      return utc-(zone[0]==='-'?-1:1)*(zoneHour*60+zoneMinute)*60000;
    }
    restart() {
      this.complete = false; this.classList.remove('is-complete','is-enhanced');
      void this.offsetWidth;
      this.update();
    }
    update() {
      const enabled = this.dataset.animation==='true' && !this.motion.matches;
      this.classList.toggle('is-enhanced',enabled);
      this.dataset.playing = String(enabled && this.sceneInView && !document.hidden && !this.userPaused && !this.editorPaused && !this.complete);
      if (this.controls) this.controls.hidden = !enabled;
      if (this.pauseButton) {
        const paused = this.userPaused || this.complete;
        const label = (paused ? this.dataset.resumeLabel : this.dataset.pauseLabel) || (paused ? 'Continuă animația' : 'Pauză animația');
        const text = this.pauseButton.querySelector('[data-dkyb-pause-label]');
        if (text) text.textContent = (paused ? this.dataset.resumeLabel : this.dataset.pauseLabel) || '';
        this.pauseButton.setAttribute('aria-label',label);
        this.pauseButton.setAttribute('aria-pressed',String(paused));
      }
      clearTimeout(this.tick);
      this.updateTimer();
    }
    updateTimer() {
      if (!this.timer || !this.timerSlot) return;
      if (!Number.isFinite(this.deadline)) {
        this.timer.hidden = true;
        this.timerSlot.hidden = this.dataset.editor!=='true';
        this.timerSlot.classList.remove('dkyb__timer-slot--configured');
        if (this.timerHelp) this.timerHelp.hidden = false;
        return;
      }
      if (this.timerHelp) this.timerHelp.hidden = true;
      const seconds = Math.max(0,Math.ceil((this.deadline-Date.now())/1000));
      if (!seconds) {
        this.timerSlot.hidden = this.timer.dataset.expiry==='hide' || !this.timer.dataset.expiredText;
        this.timer.hidden = this.timerSlot.hidden;
        this.timer.classList.add('is-expired');
        this.timer.querySelector('.dkyb__count').hidden = true;
        const expired = this.timer.querySelector('[data-dkyb-expired]');
        expired.textContent = this.timer.dataset.expiredText || '';
        expired.hidden = !expired.textContent;
        if (!this.expiredSent) { this.expiredSent = true; this.dispatchEvent(new CustomEvent('dropky:offer-countdown-expired',{bubbles:true,detail:this.eventDetail()})); }
        return;
      }
      this.timerSlot.hidden = false; this.timer.hidden = false;
      const days = Math.floor(seconds/86400),hours = Math.floor(seconds%86400/3600),minutes = Math.floor(seconds%3600/60),sec = seconds%60;
      const pad = n=>String(n).padStart(2,'0');
      const dayWrap = this.timer.querySelector('[data-dkyb-days-wrap]'),dayNode = this.timer.querySelector('[data-dkyb-days]'),unit = this.timer.querySelector('[data-dkyb-day-unit]'),clock = this.timer.querySelector('[data-dkyb-clock]');
      this.text(dayNode,String(days)); this.text(unit,days===1 ? unit.dataset.singular : unit.dataset.plural);
      if (dayWrap) dayWrap.hidden = days===0;
      this.text(clock,`${pad(hours)}:${pad(minutes)}${this.timer.dataset.seconds==='true'?':'+pad(sec):''}`);
      if (this.inView && !document.hidden) this.tick = setTimeout(()=>this.updateTimer(),this.timer.dataset.seconds==='true'?1000:Math.min(60000,seconds*1000));
    }
    text(node,value) { if (node && node.textContent!==value) node.textContent=value; }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); clearTimeout(this.tick); }
  }
  customElements.define('dk-dropky-bite-hero',DropkyBiteHero);
})();

  } catch(e) { console.error(e); }
})();
})();
